import { AtByModel } from "models/at-by-model";
import { ExternalAppModel } from "models/app/external-app";
import { GraphQLData } from "interfaces/graphql-data";
import { IApp } from "interfaces/app";
import { IAtBy } from "interfaces/at-by";
import { IEchoEdge } from "interfaces/echo-edge";
import { IEchoNode } from "interfaces/echo-node";
import { IMessageType } from "interfaces/message-type";
import { ITenant } from "interfaces/tenant";
import { MessageTypeModel } from "models/message-type/messagetype-model";
import { TenantModel } from "models/tenant/tenant-model";

export class ExternalNodeModel implements IEchoNode, GraphQLData {
  created: IAtBy = new AtByModel('', '');
  deleted: boolean = false;
  description: string = '';
  lastEvaluatedKey: string = '';
  lastModified: IAtBy = new AtByModel('', '');
  name: string = '';
  parent: IApp = new ExternalAppModel();
  receiveEdges: Array<IEchoEdge> = new Array<IEchoEdge>();
  receiveMessageType: IMessageType = new MessageTypeModel();
  scannedCount: number = 0;
  sendEdges: Array<IEchoEdge> = new Array<IEchoEdge>();
  sendMessageType: IMessageType = new MessageTypeModel();
  tenant: ITenant = new TenantModel();
  typeName: string = '';
  stopped: boolean = false;

  public static create(
    name: string,
    description: string,
    typeName: string,
    parent: IApp,
    receiveMessageType: IMessageType,
    receiveEdges: Array<IEchoEdge>,
    sendMessageType: IMessageType,
    sendEdges: Array<IEchoEdge>,
    stopped: boolean
  ): ExternalNodeModel {
    const t = new ExternalNodeModel();
    t.name = name;
    t.description = description;
    t.parent = parent;
    t.receiveEdges = receiveEdges;
    t.receiveMessageType = receiveMessageType;
    t.sendEdges = sendEdges;
    t.sendMessageType = sendMessageType
    t.typeName = typeName;
    t.stopped = stopped;
    return t;
  }

  async hydrate(data: any, tenant: ITenant): Promise<void> {
    //..
    // data.data.GetTenant.Deleted (true)
    console.log(data);
    /*if (data && data.data && data.data.GetTenant && data.data.GetTenant.Delete) {
      this.deleted = data.data.GetTenant.Delete;
    } else {
      throw new Error('data structured passed in does not contain data, data.data, data.data.GetTenant or data.data.GetTenant.Delete');
    }*/
  }
}